import React, { useEffect } from "react";
import "animate.css";
import useScrollAnimation from "../useScrollAnimation";

export function StaffMembers(props) {
  useScrollAnimation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Staff members data
  const staffMembers = [
    {
      name: "Abhijeet Barse",
      position: "CEO",
      qualifications:
        "(Alumni board member Streetfootball World, Acumen Fellow, TFIx Fellow, Member National Action & Coordination Group For Ending Violence Against Children)",
    },
    {
      name: "Sajid Jamal",
      position: "Sr. Program Manager (Community Impact Programs)",
      qualifications: "Certified Trainer from Premier Skills program.",
    },
    {
      name: "Mahima B",
      position: "Sr. Program Manager (Women's Programs)",
      qualifications:
        "Certified Mental health first aider, Trained with and developed Menstrual Health Management program and curriculum with Wash United.",
    },
    {
      name: "Pankaj Mahajan",
      position: "Sr. Program Manager (School Programs)",
      qualifications: "Ex Captain Indian team at Homeless World Cup 2013.",
    },
    {
      name: "Devang Chaya",
      position: "Program Manager",
      qualifications:
        "Senior Ex Marketing Manager at Steel Authority of India.",
    },
    {
      name: "Shivani Chaudhari",
      position: "Program Manager (Inclusion)",
      qualifications: "Diploma in Indian Sign Language.",
    },
    {
      name: "Anas Akhtar",
      position: "Manager Football Development",
      qualifications:
        "C Licence in Football Coaching. Coaching grassroots players and coaches for the past 3 years",
    },
    {
      name: "Shiba Markas",
      position: "Project Lead Women's program",
      qualifications:
        "Certified Trainer in Women's Health. Working with women's program since 2018.",
    },
  ];

  // Board members data
  const boardMembers = [
    { no: 1, name: "Mr. Ashutosh Sharma", position: "President" },
    { no: 2, name: "Ms. Suzannah Fernandez", position: "Vice-President" },
    { no: 3, name: "Mr. Virsen Barse", position: "Secretary" },
    { no: 4, name: "Mr. Warren Andrew Swaries", position: "Treasurer" },
    { no: 5, name: "Mrs. Ranjana Barse", position: "Executive Member" },
    { no: 6, name: "Mr. Mohan G Dadhi", position: "Executive Member" },
    { no: 7, name: "Mr. Sudhakar G Kalbande", position: "Executive Member" },
    { no: 8, name: "Mr. Ernest P Gaekwad", position: "Executive Member" },
    { no: 9, name: "Dr. Kirtish D Balpande", position: "Executive Member" },
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-8">
        {/* Page Title */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-orange-500 relative inline-block scroll-animate opacity-0 translate-y-50 transition-all duration-1000 delay-200">
            Our Team
            <div className="h-1 w-full bg-orange-500 mt-2"></div>
          </h1>
        </div>

        {/* Staff Members Section */}
        <section className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-orange-500 relative inline-block scroll-animate opacity-0 translate-y-50 transition-all duration-1000 delay-200">
              Staff Members
              <div className="h-1 w-full bg-orange-500 mt-2"></div>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
            {staffMembers.map((member, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg p-6 scroll-animate opacity-0 translate-y-50 transition-all duration-1000 delay-300"
              >
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  {member.name}
                </h3>
                <h4 className="text-lg font-semibold text-[#FF6600] mb-3">
                  {member.position}
                </h4>
                <p className="text-gray-600">{member.qualifications}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Board Members Section */}
        <section className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-orange-500 relative inline-block scroll-animate opacity-0 translate-y-50 transition-all duration-1000 delay-200">
              Board Members
              <div className="h-1 w-full bg-orange-500 mt-2"></div>
            </h2>
          </div>

          <div className="overflow-x-auto rounded-xl shadow-lg scroll-animate opacity-0 translate-y-50 transition-all duration-1000 delay-300">
            <table className="min-w-full bg-white">
              <thead className="bg-[#efc94c] text-white">
                <tr>
                  <th className="py-4 px-6 text-left font-semibold text-gray-800">
                    No.
                  </th>
                  <th className="py-4 px-6 text-left font-semibold text-gray-800">
                    Name
                  </th>
                  <th className="py-4 px-6 text-left font-semibold text-gray-800">
                    Position on Board
                  </th>
                </tr>
              </thead>
              <tbody>
                {boardMembers.map((member, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                  >
                    <td className="py-4 px-6 text-gray-700 border-b border-gray-200">
                      {member.no}
                    </td>
                    <td className="py-4 px-6 text-gray-800 font-medium border-b border-gray-200">
                      {member.name}
                    </td>
                    <td className="py-4 px-6 text-gray-700 border-b border-gray-200">
                      {member.position}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  );
}
